<template>
  <div>
    <el-dialog
      title="供应商评分明细一览表"
      v-bind="this.$attrs"
      width="990px"
      @close="close"
      class="dialog-sourcingflow-zindex dialog-zindex ccui-multifunctional-table-wrapper-detail"
    >
      <div class="ccui-multifunctional-table-wrapper">
        <el-group-title class="ccui-group-wrapper d_jump" index="contract">
          <template slot="groupTitle">
            <el-table :data="datatow" border>
              <el-table-column
                width="50px"
                prop="id"
                label="序号"
              ></el-table-column>
              <el-table-column
                v-for="(item, index) in columnstow"
                :key="index"
                :show-overflow-tooltip="true"
                v-bind="item"
              >
                <template v-if="item.labelChild && item.labelChild.length > 0">
                  <el-table-column
                    v-for="(child, indexch) in item.labelChild"
                    :key="indexch"
                    v-bind="child"
                  >
                    <template slot="header">
                      <div style="text-align: center;width:100%;padding:0;">
                        {{ child.label }}
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <span>{{
                        scope.row[child.prop] || scope.row[child.prop] === 0
                          ? scope.row[child.prop]
                          : "--"
                      }}</span>
                    </template>
                  </el-table-column>
                </template>
                <template slot-scope="scope">
                  <span>{{ scope.row[item.prop] }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-group-title>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="close"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { qrySumScoreSupScoreDetail } from "@/app/sourcingFlow/api/expertEvaluation";
import BigNumber from "bignumber.js";
export default {
  name: "evaluationResultDialog",
  props: {
    dialogData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      datatow: [],
      columnstow: [
        {
          prop: "expertName",
          label: "评分专家"
        },
        {
          prop: "sumScoreone",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sumScoretow",
          label: "商务",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sumScore",
          label: "合计得分",
          align: "center"
        },
        {
          prop: "scoreDesc",
          label: "打分说明"
        }
      ]
    };
  },
  created() {
    if (this.getDialogData.sumScoreType == 0) {
      this.columnstow = this.columnstow.filter(item => {
        return item.prop != "sumScoretow";
      });
    }
    this.getSumScoreExpertScoreList();
  },
  computed: {
    getDialogData() {
      return this.dialogData;
    }
  },
  methods: {
    //打分表查询
    getSumScoreExpertScoreList() {
      let param = {
        schemeId: this.getDialogData.schemeId,
        packId:
          this.getDialogData.packId !== "0" ? this.getDialogData.packId : "",
        supCode: this.getDialogData.supCode,
        sumScoreType: this.getDialogData.sumScoreType
      };
      qrySumScoreSupScoreDetail(param).then(res => {
        if (res.data.code === "0") {
          let columns = JSON.parse(JSON.stringify(this.columnstow));
          let data = [];
          let Obj = {
            expertName: "汇总得分",
            sumScore: 0
          }; //汇总
          let maxOrMinobj = {};
          res.data.data.maxMinScoreItemBOList.forEach(o => {
            if (maxOrMinobj[o.scoreItemId]) {
              maxOrMinobj[o.scoreItemId].push(o.minValue);
              maxOrMinobj[o.scoreItemId].push(o.maxValue);
            } else {
              maxOrMinobj[o.scoreItemId] = [o.minValue];
              maxOrMinobj[o.scoreItemId].push(o.maxValue);
            }
          });
          console.log(maxOrMinobj);
          if (res.data.data.isMaxAndMin == 0) {
            //isMaxAndMin等于0不用去掉最高最低
            maxOrMinobj = {};
          }
          res.data.data.sscSupScoreDetailBOS.forEach((item, index) => {
            item.id = data.length + 1;
            item.sumScore = 0;
            if (item.supScoreItemBOs && item.supScoreItemBOs.length > 0) {
              item.supScoreItemBOs.forEach((itemSup, indexSup) => {
                if (itemSup.scoreItem == 0) {
                  itemSup.sscSupScoreItemScoreBOs.forEach(
                    (itemfree, indexfree) => {
                      if (
                        maxOrMinobj[itemfree.scoreItemId] &&
                        maxOrMinobj[itemfree.scoreItemId].includes(
                          itemfree.supScore
                        )
                      ) {
                        maxOrMinobj[itemfree.scoreItemId].forEach((it, i) => {
                          if (it == itemfree.supScore) {
                            maxOrMinobj[itemfree.scoreItemId].splice(i, 1); //由于最高分只能去掉一个，第二个同样的最高分就不用去掉了
                          }
                        });
                        itemfree.isMaxorMin = true;
                      }
                      let bool = true;
                      columns[1].labelChild.forEach((itemCol, indexCol) => {
                        if (itemCol.prop == "supScore" + itemfree.scoreItemId) {
                          bool = false;
                        }
                      });
                      let prop = "supScore" + itemSup.scoreItem + indexfree;
                      if (itemfree.supScore || itemfree.supScore === 0) {
                        item.sumScore += itemfree.supScore - 0;
                        if (!Obj[prop]) {
                          Obj[prop] = 0;
                        }
                        if (
                          !itemfree.isMaxorMin ||
                          res.data.data.sscSupScoreDetailBOS.length < 3
                        ) {
                          //102为去掉最高分、最低分
                          // Obj[prop] += itemfree.supScore - 0;
                          Obj[prop] = new BigNumber(Number(Obj[prop])).plus(
                            Number(itemfree.supScore)
                          );
                        }
                        item[prop] = new BigNumber(itemfree.supScore).toFormat(
                          2
                        );
                      }
                      if (Obj["len" + prop]) {
                        if (
                          (itemfree.supScore || itemfree.supScore === 0) &&
                          !itemfree.isMaxorMin
                        ) {
                          Obj["len" + prop] += 1;
                        } else if (
                          (itemfree.supScore || itemfree.supScore === 0) &&
                          itemfree.isMaxorMin &&
                          res.data.data.sscSupScoreDetailBOS.length < 3
                        ) {
                          Obj["len" + prop] += 1;
                        }
                      } else {
                        if (
                          (itemfree.supScore || itemfree.supScore === 0) &&
                          !itemfree.isMaxorMin
                        ) {
                          Obj["len" + prop] = 1;
                        } else if (
                          (itemfree.supScore || itemfree.supScore === 0) &&
                          itemfree.isMaxorMin &&
                          res.data.data.sscSupScoreDetailBOS.length < 3
                        ) {
                          Obj["len" + prop] = 1;
                        } else {
                          Obj["len" + prop] = 0;
                        }
                      }
                      if (bool) {
                        columns[1].labelChild.push({
                          prop: prop,
                          label: itemfree.scoreRule,
                          align: "center"
                        });
                        let uniqueArr = columns[1].labelChild.filter(
                          (item, index) =>
                            columns[1].labelChild.findIndex(
                              i => i.prop === item.prop
                            ) === index
                        );
                        columns[1].labelChild = uniqueArr;
                        console.log(columns[1], uniqueArr, "columns");
                      }
                    }
                  );
                } else if (itemSup.scoreItem == 1) {
                  itemSup.sscSupScoreItemScoreBOs.forEach(
                    (itemfree, indexfree) => {
                      let bool = true;
                      columns[2].labelChild.forEach((itemCol, indexCol) => {
                        if (itemCol.prop == "supScore" + itemfree.scoreItemId) {
                          bool = false;
                        }
                      });
                      let prop = "supScore" + itemSup.scoreItem + indexfree;
                      if (itemfree.supScore || itemfree.supScore === 0) {
                        if (!Obj[prop]) {
                          Obj[prop] = 0;
                        }
                        Obj[prop] += itemfree.supScore - 0;
                        item.sumScore += itemfree.supScore - 0;
                        item[prop] = new BigNumber(itemfree.supScore).toFormat(
                          2
                        );
                      }
                      if (Obj["len" + prop]) {
                        if (itemfree.supScore || itemfree.supScore === 0) {
                          Obj["len" + prop] += 1;
                        }
                      } else {
                        if (itemfree.supScore || itemfree.supScore === 0) {
                          Obj["len" + prop] = 1;
                        } else {
                          Obj["len" + prop] = 0;
                        }
                      }
                      if (bool) {
                        columns[2].labelChild.push({
                          prop: prop,
                          label: itemfree.scoreRule,
                          align: "center"
                        });
                        let uniqueArr = columns[2].labelChild.filter(
                          (item, index) =>
                            columns[2].labelChild.findIndex(
                              i => i.prop === item.prop
                            ) === index
                        );
                        columns[2].labelChild = uniqueArr;
                      }
                    }
                  );
                }
              });
            }
            Obj.sumScore = new BigNumber(Number(Obj.sumScore)).plus(
              Number(item.sumScore)
            );
            item.sumScore = new BigNumber(item.sumScore).toFormat(2);
            data.push(item);
          });
          // res.data.data.length &&
          //   (Obj.sumScore = Obj.sumScore / res.data.data.length);
          this.$set(this, "columnstow", columns);
          console.log(this.columnstow, "columns");
          for (var key in Obj) {
            if (
              key != "expertName" &&
              key != "sumScore" &&
              res.data.data.sscSupScoreDetailBOS.length &&
              key.indexOf("len") == -1
            ) {
              Obj[key] = Obj[key] / Obj["len" + key];
            }
            if (key != "expertName") {
              Obj[key] = new BigNumber(Obj[key]).toFormat(2);
            }
          }
          Obj.sumScore = new BigNumber(this.dialogData.sumScore).toFormat(2);
          data.push(Obj);
          console.log(data);
          this.$nextTick(() => {
            this.datatow = data;
          });
        }
      });
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-contractor-detail-form-item {
  margin: 30px 20px;
}
.ccui-group-wrapper {
  /deep/ .el-table .el-table__body .cell {
    height: 36px;
    line-height: 36px;
  }
}
.form_item {
  width: 260px;
}
.col-bottom {
  margin-bottom: 20px;
}
.rel {
  position: relative;
}
.sub-btnbox {
  text-align: right;
  margin-bottom: 20px;
}
</style>
